import styled from 'styled-components';

export const ItemInformationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: top;
  font-size: 1.5rem;
  margin-left: 3.125rem;
  margin-top: 1.875rem;
`;
export const TitleItemWrapper = styled.div`
  width: 18.813rem;
`;
export const TitleValueWrapper = styled.div`
  max-width: 40rem;
  word-break: break-all;
`;
